import styled from "@emotion/styled";
import { CircularProgress, Typography } from "@avenue-8/sidekick-ui";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background-color: ${(p) => p.theme.colors.background};
`;

export const CenteredLoadingSpinner = () => (
  <Container>
    <Typography>
      <CircularProgress />
    </Typography>
  </Container>
);
